import {
    FETCH_CO_REPORTERS_START,
    FETCH_CO_REPORTERS_SUCCESS,
    FETCH_CO_REPORTERS_ERROR
} from '../../actions/mis/coReportersAction';

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    coReporters: [],
};

const coReportersReducer = (state = INIT_STATE, action) => {
    let newState;
    let index;
    switch (action.type) {
        case FETCH_CO_REPORTERS_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_CO_REPORTERS_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, coReporters: action.coReporters.length > 0 ? [...action.coReporters] : [] };
        }
        case FETCH_CO_REPORTERS_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }

        default:
            return state;
    }
}

export default coReportersReducer;